// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import store from './store/'
import router from './router'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import DatePicker from 'vue2-datepicker'
import VueApexCharts from 'vue-apexcharts'
import { Loader } from '@googlemaps/js-api-loader'
import { Decimal } from 'decimal.js-light'
import VXETable from 'vxe-table'
import VueLazyLoad from 'vue-lazyload'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vxe-table/lib/style.css'
import 'xe-utils'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import 'vue2-datepicker/index.css'
import createGoogleButton from './plugin/createGoogleButton'

// ------scss或組件樣式請引用在上方------
import '@/assets/style/index.scss'
import '@/assets/style/custom.scss'

// eslint-disable-next-line no-extend-native
Number.prototype.toFixed = function (n) {
  let d = new Decimal(this)
  let precision = d.precision()
  for (let i = precision; i >= 2; i--) {
    d = d.toDecimalPlaces(i)
  }
  return d.toString()
}

// eslint-disable-next-line no-extend-native
Number.prototype.toFixedNumber = function (n) {
  return Number(Number(this).toFixed(n))
}

Vue.use(DatePicker) // 使用DatePicker
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VXETable)
Vue.use(Vuex)
Vue.use(VueApexCharts)
Vue.component('date-picker', DatePicker)
Vue.component('apex-chart', VueApexCharts)

const loadingPicture = require('@/assets/bgGray.png')

Vue.use(VueLazyLoad, {
  error: loadingPicture,
  loading: loadingPicture,
  preLoad: 1.3,
  attempt: 1,
  // set observer to true
  observer: true,
  // optional
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1
  }
})

Vue.use(createGoogleButton)

Vue.config.productionTip = false
Vue.prototype.$VXETable = VXETable
Vue.prototype.$googleMapLoader = new Loader({
  apiKey: process.env.GOOGLE_MAP_API_KEY,
  libraries: ['places', 'marker'],
  version: '3.52'
})

/* eslint-disable no-new */
new Vue({
  // i18n,
  el: '#app',
  store: new Vuex.Store(store),
  router,
  components: { App },
  template: '<App/>'
})
// .$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js